import script from "./AccessibilityControls.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessibilityControls.vue?vue&type=script&setup=true&lang=js"

import "./AccessibilityControls.vue?vue&type=style&index=0&id=aaefe228&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaefe228"]])

export default __exports__